export default "__VITE_ASSET__83efff05__"